enum UserType {
    CORE = 'core',
    WORKSPACE = 'workspace',
    CLIENT = 'client',
}

export default UserType;
